// Generated by CoffeeScript 2.7.0
var addColorMark, alignActive, alignCommand, blockActive, canInsert, colors, headings, markActive, promptForURL, setActiveColor, setTextAlign;

import {
  openMaterialPickModal
} from 'trunks/vue/admin/components/modals/material_library_modal.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import {
  AllSelection
} from 'prosemirror-state';

import {
  Slice,
  Fragment
} from 'prosemirror-model';

import {
  lift,
  setBlockType,
  toggleMark,
  wrapIn
} from 'prosemirror-commands';

import {
  wrapInList
} from 'prosemirror-schema-list';

import {
  redo,
  undo
} from 'prosemirror-history';

import schema from './schema.js';

import {
  icons,
  colorList,
  headingList,
  ALLOW_ALIGN_NODE_TYPES
} from './assets.js';

addColorMark = function(type, attrs = {}) {
  return function(state, dispatch) {
    var $cursor, $from, $to, empty, i, len, range, ranges, tr;
    ({empty, $cursor, ranges} = state.selection);
    if (empty && !$cursor) {
      return false;
    }
    if (dispatch) {
      if ($cursor) {
        dispatch(state.tr.addStoredMark(type.create(attrs)));
      } else {
        tr = state.tr;
        for (i = 0, len = ranges.length; i < len; i++) {
          range = ranges[i];
          ({$from, $to} = range);
          tr.addMark($from.pos, $to.pos, type.create(attrs));
        }
        dispatch(tr.scrollIntoView());
      }
    }
    return true;
  };
};

markActive = function(type, attrs = {}) {
  return function(state) {
    var $from, empty, from, to;
    ({from, $from, to, empty} = state.selection);
    if (empty) {
      return type.isInSet(state.storedMarks || $from.marks());
    } else {
      return state.doc.rangeHasMark(from, to, type);
    }
  };
};

blockActive = function(type, attrs = {}) {
  return function(state) {
    var $from, node, to;
    ({$from, to, node} = state.selection);
    if (node) {
      return node.hasMarkup(type, attrs);
    }
    return to <= $from.end() && $from.parent.hasMarkup(type, attrs);
  };
};

canInsert = function(state, type) {
  var $from, d, i, index, ref;
  $from = state.selection.$from;
  for (d = i = 0, ref = $from.depth; (0 <= ref ? i <= ref : i >= ref); d = 0 <= ref ? ++i : --i) {
    index = $from.index(d);
    if ($from.node(d).canReplaceWith(index, index, type)) {
      return true;
    }
  }
  return false;
};

promptForURL = function() {
  var url;
  url = window && window.prompt('Enter the URL', 'https://');
  if (url && !/^https?:\/\//i.test(url)) {
    url = 'http://' + url;
  }
  return url;
};

setActiveColor = function(picker, color) {
  return picker.active = color;
};

alignCommand = function(align) {
  return function(state, dispatch) {
    var selection, tr;
    selection = state.selection;
    tr = setTextAlign(state.tr.setSelection(selection), align);
    if (tr.docChanged) {
      if (typeof dispatch === "function") {
        dispatch(tr);
      }
      return true;
    }
    return false;
  };
};

setTextAlign = function(tr, alignment = null) {
  var doc, from, selection, set_align_jobs, to;
  ({selection, doc} = tr);
  if (!selection || !doc) {
    return tr;
  }
  ({from, to} = selection);
  set_align_jobs = [];
  // http: //prosemirror.net/docs/ref/#model.Node.nodesBetween
  doc.nodesBetween(from, to, function(node, pos) {
    var align, nodeType;
    nodeType = node.type;
    align = node.attrs.align || null;
    if (align !== alignment && _.includes(ALLOW_ALIGN_NODE_TYPES, nodeType.name)) {
      set_align_jobs.push({node, pos, nodeType});
    }
    return true;
  });
  set_align_jobs.forEach(function(job) {
    var attrs, node, nodeType, pos;
    ({node, pos, nodeType} = job);
    ({attrs} = node);
    attrs = {
      ...attrs,
      align: alignment
    };
    // http: //prosemirror.net/docs/ref/#transform.Transform.setNodeMarkup
    return tr = tr.setNodeMarkup(pos, nodeType, attrs, node.marks);
  });
  return tr;
};

alignActive = function(align) {
  return function(state) {
    var active, doc, from, selection, to;
    ({selection, doc} = state);
    ({from, to} = selection);
    active = false;
    doc.nodesBetween(from, to, function(node) {
      if (!active && node.attrs.align === align) {
        active = true;
      }
      return !active;
    });
    return active;
  };
};

export var buttons = {
  strong: {
    icon: icons.strong,
    active: markActive(schema.marks.strong),
    run: toggleMark(schema.marks.strong)
  },
  underline: {
    icon: icons.underline,
    active: markActive(schema.marks.underline),
    run: toggleMark(schema.marks.underline)
  },
  em: {
    icon: icons.em,
    active: markActive(schema.marks.em),
    run: toggleMark(schema.marks.em)
  },
  strikethrough: {
    icon: icons.strikethrough,
    active: markActive(schema.marks.strikethrough),
    run: toggleMark(schema.marks.strikethrough)
  },
  code: {
    icon: icons.code,
    active: markActive(schema.marks.code),
    run: toggleMark(schema.marks.code)
  },
  blockquote: {
    icon: icons.blockquote,
    active: blockActive(schema.nodes.blockquote),
    enable: wrapIn(schema.nodes.blockquote),
    run: wrapIn(schema.nodes.blockquote)
  },
  hr: {
    icon: icons.hr,
    enable: function(state) {
      return canInsert(state, schema.nodes.horizontal_rule);
    },
    run: function(state, dispatch) {
      var hr;
      hr = schema.nodes.horizontal_rule.create();
      return dispatch(state.tr.replaceSelectionWith(hr));
    }
  },
  link: {
    icon: icons.link,
    active: markActive(schema.marks.link),
    enable: function(state) {
      return !state.selection.empty;
    },
    run: function(state, dispatch) {
      var href;
      if (markActive(schema.marks.link)(state)) {
        toggleMark(schema.marks.link)(state, dispatch);
        return true;
      }
      href = promptForURL();
      if (!href) {
        return false;
      }
      return toggleMark(schema.marks.link, {href})(state, dispatch);
    }
  },
  align_left: {
    icon: icons.align_left,
    run: alignCommand('left')
  },
  align_center: {
    icon: icons.align_center,
    active: alignActive('center'),
    run: alignCommand('center')
  },
  align_right: {
    icon: icons.align_right,
    active: alignActive('right'),
    run: alignCommand('right')
  },
  align_justify: {
    icon: icons.align_justify,
    active: alignActive('justify'),
    run: alignCommand('justify')
  },
  ordered_list: {
    icon: icons.ordered_list,
    active: blockActive(schema.nodes.ordered_list),
    enable: wrapInList(schema.nodes.ordered_list),
    run: wrapInList(schema.nodes.ordered_list)
  },
  bullet_list: {
    icon: icons.bullet_list,
    active: blockActive(schema.nodes.bullet_list),
    enable: wrapInList(schema.nodes.bullet_list),
    run: wrapInList(schema.nodes.bullet_list)
  },
  lift: {
    icon: icons.lift,
    enable: lift,
    run: lift
  },
  undo: {
    icon: icons.undo,
    enable: undo,
    run: undo
  },
  redo: {
    icon: icons.redo,
    enable: redo,
    run: redo
  },
  clear: {
    icon: icons.clear,
    run: function(state, dispatch) {
      var $from, $to, empty, newSelection, tr;
      ({empty} = state.selection);
      tr = state.tr;
      if (empty) {
        newSelection = new AllSelection(state.doc);
        ({$from, $to} = newSelection);
        tr.setSelection(newSelection);
      } else {
        ({$from, $to} = state.selection);
      }
      setActiveColor(pickers.text_color, null);
      setActiveColor(pickers.text_bg_color, null);
      tr.removeMark($from.pos, $to.pos, null);
      return dispatch(tr.scrollIntoView());
    }
  },
  imgae: {
    icon: icons.image,
    enable: function(state) {
      return canInsert(state, schema.nodes.image);
    },
    run: function(state, dispatch, view) {
      var picker_modal;
      picker_modal = openMaterialPickModal();
      return picker_modal.$on('ensureClicked', function(materials) {
        var imageNodes, slice;
        imageNodes = _.map(materials, function(material) {
          var img;
          if (material.download_url) {
            return img = schema.nodes.image.createAndFill({
              src: material.download_url
            });
          }
        });
        slice = new Slice(Fragment.from(imageNodes), 0, 0);
        dispatch(state.tr.replaceSelection(slice).scrollIntoView());
        return view.focus();
      });
    }
  }
};

headings = _.map(headingList, function(level) {
  if (level) {
    return {
      content: `<h${level}>标题${level}</h${level}>`,
      active: blockActive(schema.nodes.heading, {
        level: level
      }),
      enable: setBlockType(schema.nodes.heading, {
        level: level
      }),
      run: setBlockType(schema.nodes.heading, {
        level: level
      })
    };
  } else {
    return {
      content: "默认",
      run: setBlockType(schema.nodes.paragraph)
    };
  }
});

colors = _.reduce(['text', 'text_bg'], function(memo, type) {
  memo[type] = _.map(colorList, function(color) {
    return {
      content: `<span class='color-item' style='background-color: ${color}'></span>`,
      run: function(state, dispatch) {
        var mark_type;
        mark_type = `${type}_color`;
        setActiveColor(pickers[mark_type], color);
        return addColorMark(schema.marks[mark_type], {
          color: color
        })(state, dispatch);
      }
    };
  });
  return memo;
}, {});

export var pickers = {
  heading: {
    icon: icons.heading,
    children: headings
  },
  text_color: {
    icon: icons.text_color,
    children: colors.text,
    active: null
  },
  text_bg_color: {
    icon: icons.text_bg_color,
    children: colors.text_bg,
    active: null
  }
};
